import React, { createContext, useContext, useReducer } from "react";
import { profileReducer } from "../reducers/profileReducer";
import { initialFilterParks, initialSummary } from "../Data/parks";
import { initialGenInfo, initialGenInfoErr } from "Data/userAccount";

//Create context
export const ProfileContext = createContext();

//Initial state
const initialState = {
  //for profile View of looged-in user
  userProfileView: null,
  loadingProfile: true,
  profileError: '',

  //user Account Setting
  userAccData: null,
  accountLoading: true,
  accountError: '',
  //Gen Info FOrm
  activeTab: 'general',
  genInfoForm: initialGenInfo,
  genInfoLoading: false,
  genInfoErrors: initialGenInfoErr,
  //profile  image
  profilePhotoLoading: false,
  profilePhotoError: '',
  profilePhotoFile: null,

  //Cover Photo
  coverPhotoLoading: false,
  coverPhotoError: '',
  coverPhotoFile: null,

  //shared safaries
  userSharedSafariOrg: [],
  userSharedSafariOrgLoading: true,
  userSharedSafariOrgError: '',

  userSharedSafariJoind: [],
  userSharedSafariJoindLoading: true,
  userSharedSafariJoindError: '',

};

//Provider
const ProfileProvider = ({ children }) => {
  const [profileState, profileDispatch] = useReducer(profileReducer, initialState);
  return (
    <ProfileContext.Provider
      value={{
        ...profileState,
        profileDispatch,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

//hook
export const useProfileContext = () => useContext(ProfileContext);

export default ProfileProvider;
